export const CURRENCY_DISPLAY_MAP = {
  BTC_TEST: 'BTC',
  ETH_TEST5: 'ETH',
}
